import {CustomerLedgerGlEntry, type CustomerLedgerGlEntryData} from "@/types/erp/customerLedgerGlEntry";
import {Invoice, type InvoiceData} from "@/types/invoices/Invoice";
import {SeaInvoice, type SeaInvoiceData} from "@/types/invoices/SeaInvoice";
import {Company,type CompanyData} from "@/types/company/company";
import {StrongoInvoice,type StrongoInvoiceData} from "@/types/invoices/StrongoInvoice.ts";
import {
    CustomerLedgerEntryReversal,
    type CustomerLedgerEntryReversalData
} from "@/types/erp/customerLedgerEntryReversal.ts";
import {StrongoInvoiceHistory, type StrongoInvoiceHistoryData} from "@/types/invoices/StrongoInvoiceHistory.ts";

export class CustomerLedgerEntry {
    public id:number|null;
    public entry_no:number|null;
    public company_id:number|null;
    public customer_no:string;
    public customer_name:string;
    public document_type:number|null;
    public document_no:string;
    public document_date:Date|null;
    public due_date:Date|null;
    public closed_at_date:Date|null;
    public ext_document_no:string;
    public currency_code:string;
    public sales_lcy:number|null;
    public amount_lcy:number|null;
    public amount:number|null;
    public original_amount:number|null;
    public original_amount_lcy:number|null;
    public remaining_amt_lcy:number|null;
    public remaining_amount:number|null;
    public days_until_payment:number|null;
    public overdue_days:number;
    public invoice_dso:number;
    public global_dimension_1_code:string;
    public document_path:string|null;
    public document_name:string|null;
    public customerLedgerGlEntries:CustomerLedgerGlEntry[];
    public invoice:Invoice | null;
    public seaInvoice:SeaInvoice | null;
    public strongoInvoices:StrongoInvoice[];
    public customerLedgerEntryReversal:CustomerLedgerEntryReversal| null;
    public customerLedgerEntryOriginal:CustomerLedgerEntryReversal| null;
    public invoicedAwbs:StrongoInvoice[];
    public strongoInvoiceHistories: StrongoInvoiceHistory[];
    public company: Company | null;

    constructor(data:CustomerLedgerEntryData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.entry_no = null;
            this.company_id = null;
            this.customer_no = "";
            this.customer_name = "";
            this.document_type = null;
            this.document_no = "";
            this.document_date = null;
            this.due_date = null;
            this.closed_at_date = null;
            this.ext_document_no = "";
            this.currency_code = "";
            this.sales_lcy = null;
            this.amount_lcy = null;
            this.amount = null;
            this.original_amount = null;
            this.original_amount_lcy = null;
            this.remaining_amt_lcy = null;
            this.remaining_amount = null;
            this.days_until_payment = null;
            this.overdue_days = 0;
            this.invoice_dso = 0;
            this.global_dimension_1_code = "";
            this.document_path = null;
            this.document_name = null;
            this.customerLedgerGlEntries = [];
            this.invoice = null;
            this.seaInvoice = null;
            this.strongoInvoices = [];
            this.customerLedgerEntryReversal = null;
            this.customerLedgerEntryOriginal = null;
            this.invoicedAwbs = [];
            this.strongoInvoiceHistories = [];
            this.company = null;
        }
        else
        {
            this.id = data.id;
            this.entry_no =data.entry_no
            this.company_id =data.company_id
            this.customer_no =data.customer_no;
            this.customer_name =data.customer_name;
            this.document_type =data.document_type;
            this.document_no =data.document_no;
            this.document_date = null;
            if(data.document_date !== null)
            {
                this.document_date = new Date(data.document_date);
            }
            this.due_date = null;
            if(data.due_date !== null)
            {
                this.due_date = new Date(data.due_date);
            }
            this.closed_at_date = null;
            if(data.closed_at_date !== null)
            {
                this.closed_at_date = new Date(data.closed_at_date);
            }
            this.ext_document_no =data.ext_document_no;
            this.currency_code =data.currency_code;
            this.sales_lcy =data.sales_lcy;
            this.amount_lcy =data.amount_lcy;
            this.amount =data.amount;
            this.original_amount =data.original_amount;
            this.original_amount_lcy =data.original_amount_lcy;
            this.remaining_amt_lcy =data.remaining_amt_lcy;
            this.remaining_amount =data.remaining_amount;
            this.days_until_payment =data.days_until_payment;
            this.overdue_days =data.overdue_days;
            this.invoice_dso =data.invoice_dso;
            this.global_dimension_1_code =data.global_dimension_1_code;
            this.document_path =data.document_path;
            this.document_name =data.document_name;
            this.customerLedgerGlEntries = [];
            if (data.customerLedgerGlEntries !== undefined) {
                data.customerLedgerGlEntries.forEach(customerLedgerGlEntry => this.customerLedgerGlEntries.push((new CustomerLedgerGlEntry(customerLedgerGlEntry))));
            }
            this.invoice = null;
            if (data.invoice !== undefined && data.invoice !== null) {
                this.invoice = new Invoice(data.invoice)
            }
            this.seaInvoice = null;
            if (data.seaInvoice !== undefined && data.seaInvoice !== null) {
                this.seaInvoice = new SeaInvoice(data.seaInvoice)
            }
            this.strongoInvoices = [];
            if (data.strongoInvoices !== undefined) {
                data.strongoInvoices.forEach(strongoInvoice => this.strongoInvoices.push((new StrongoInvoice(strongoInvoice))));
            }
            this.customerLedgerEntryReversal = null;
            if (data.customerLedgerEntryReversal !== undefined && data.customerLedgerEntryReversal !== null) {
                this.customerLedgerEntryReversal = new CustomerLedgerEntryReversal(data.customerLedgerEntryReversal)
            }
            this.customerLedgerEntryOriginal = null;
            if (data.customerLedgerEntryOriginal !== undefined && data.customerLedgerEntryOriginal !== null) {
                this.customerLedgerEntryOriginal = new CustomerLedgerEntryReversal(data.customerLedgerEntryOriginal)
            }
            this.invoicedAwbs = [];
            if (data.invoicedAwbs !== undefined) {
                data.invoicedAwbs.forEach(invoicedAwb => this.invoicedAwbs.push((new StrongoInvoice(invoicedAwb))));
            }
            this.strongoInvoiceHistories = [];
            if (data.strongoInvoiceHistories !== undefined) {
                data.strongoInvoiceHistories.forEach(strongoInvoiceHistory => this.strongoInvoiceHistories.push((new StrongoInvoiceHistory(strongoInvoiceHistory))));
            }
            this.company = null;
            if (data.company !== undefined && data.company !== null) {
                this.company = new Company(data.company)
            }
        }
    }
}

export type CustomerLedgerEntryData = {
    id:number|null;
    entry_no:number|null;
    company_id:number|null;
    customer_no:string;
    customer_name:string;
    document_type:number|null;
    document_no:string;
    document_date:Date|null;
    due_date:Date|null;
    closed_at_date:Date|null;
    ext_document_no:string;
    currency_code:string;
    sales_lcy:number|null;
    amount_lcy:number|null;
    amount:number|null;
    original_amount:number|null;
    original_amount_lcy:number|null;
    remaining_amt_lcy:number|null;
    remaining_amount:number|null;
    days_until_payment:number|null;
    overdue_days:number;
    invoice_dso:number;
    global_dimension_1_code:string;
    document_path:string|null;
    document_name:string|null;
    customerLedgerGlEntries:CustomerLedgerGlEntryData[];
    invoice:InvoiceData|null;
    seaInvoice:SeaInvoiceData|null;
    strongoInvoices:StrongoInvoiceData[];
    customerLedgerEntryReversal:CustomerLedgerEntryReversalData|null;
    customerLedgerEntryOriginal:CustomerLedgerEntryReversalData|null;
    invoicedAwbs:StrongoInvoiceData[];
    strongoInvoiceHistories: StrongoInvoiceHistoryData[];
    company:CompanyData|null;

}